export interface FormSubmitOptions {
  action: string
  method: 'GET' | 'POST'
  target: string
  data: Record<string, string>
}

export function submitFormToTarget({ action, method, target, data }: FormSubmitOptions): void {
  const form = document.createElement('form')
  form.style.display = 'none'
  form.action = action
  form.method = method
  form.target = target

  for (const [name, value] of Object.entries(data)) {
    const input = document.createElement('input')
    input.type = 'hidden'
    input.name = name
    input.value = value
    form.appendChild(input)
  }

  document.body.appendChild(form)
  form.submit()
  requestAnimationFrame(() => form.remove())
}
